import React, { useState, useEffect, useMemo } from "react";
import { Line } from "react-chartjs-2";
import { Form, Row, Col } from "react-bootstrap";

// Import Chart.js modules for compatibility
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js modules
ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

import calculatePHS from "./PHSmodel-ISO7933_2023";
import calculateWBGT from "./WBGT-ISO7243_2017";





function newtonRaphson(f, x0, tol = 1e-6, maxIter = 1000, alpha=1e-1) {
  let x = x0; // Point de départ
  for (let i = 0; i < maxIter; i++) {
    const fx = f(x);
    const dfx = (f(x + 1e-6) - fx) / 1e-6; // Approximation numérique de la dérivée
    if (Math.abs(dfx) < tol) {
      throw new Error("La dérivée est trop proche de zéro");
    }
    console.log("x", x)
    console.log("fx", fx)
    console.log("dfx", dfx)

    // const nextX = x - fx / dfx; // Formule de Newton-Raphson
    const nextX = x - alpha * fx / dfx; // Formule de Newton-Raphson
    // if (Math.abs(nextX - x) < tol && Math.abs(fx) < tol) {
    if (Math.abs(nextX - x) < tol) {
      console.log("Solution trouvée", nextX)
      return nextX; // Solution trouvée
    }
    x = nextX; // Mise à jour

  }
  throw new Error("Newton-Raphson n'a pas convergé");
}





function PHS() {
  const [params, setParams] = useState({
    Ta: 39,
    RH: 75,
    Tg: 50,
    D: 15,
    Va: 1,
    M: 300,
    Weight: 75,
    Height: 1.8,
    Accl: 1,
    Drink: 1,
    Duration: 480,

    Work: 0,
    Icl: 0.5,
    imst: 0.38,
    Ap: 0.54,
    Fr: 0.42,
    Ecl: 0.97,
    posture: 1,
  });


//   const [results, setResults] = useState(null);
  const [results, setResults] = useState({
    PHS_data: [],
    Dlimloss_50: 0,
    Dlimloss_95: 0,
    Dlimtcr: 0,
  });

  const [wbgt, setwbgt] = useState({
    WBGT: 28,
    WBGT_stull: 27,
  });
  
  const [TcreData, SetTcreData] = useState({
    labels: [],
    datasets: [
      {
        label: "Tre (°C)",
        data: [],
        borderColor: "red",
        borderWidth: 2,
        fill: false,
      },
      {
        label: "Tcr (°C)",
        data: [],
        borderColor: "blue",
        borderWidth: 2,
        fill: false,
      },
      {
        label: "Tsk (°C)",
        data: [],
        borderColor: "green",
        borderWidth: 2,
        fill: false,
      },
    ],
  });
  const [sweatLossData, SetsweatLossData] = useState({
    labels: [],
      datasets: [
        {
          label: "SWtot (g)",
          data: [],
          borderColor: "purple",
          borderWidth: 2,
          fill: false,
        },
      ],
  });




  const calculateTr = (Tg, Va, Ta, D = 15, epsilon_g = 0.95) => {
    
    const Tr = Math.pow(
      Math.pow(Tg + 273, 4) +
        (1.1e8 * Math.pow(Va, 0.6)) / (epsilon_g * Math.pow(D / 100, 0.4)) * (Tg - Ta),
      0.25
    ) - 273;
  
    return Math.round(Tr * 10) / 10; // Arrondir à une décimale sans convertir en chaîne
  };
  
  const calculateTgFromTr = (Tr, Va, Ta, D = 15, epsilon_g = 0.95) => {
    // Approximation itérative pour Tg
    const equation = (Tg) =>
      Math.pow(Tg + 273, 4) +
      (1.1e8 * Math.pow(Va, 0.6)) / (epsilon_g * Math.pow(D / 100, 0.4)) * (Tg - Ta) -
      Math.pow(Tr + 273, 4);
  
    // Utiliser Newton-Raphson pour résoudre
    const Tg = newtonRaphson(equation, Tr); // Point de départ = Tr
  
    return Math.round(Tg); // Arrondir à l'entier le plus proche sans convertir en chaîne
  };
  






  const Tr = calculateTr(params.Tg, params.Va, params.Ta)



  // Met à jour les résultats dès que les paramètres changent
  useEffect(() => {
    // const {
    //     PHS_data,
    //     Dlimloss_50,
    //     Dlimloss_95,
    //     Dlimtcr
    // } = calculatePHS(params);
    // const {
    //     PHS_data,
    //     Dlimloss_50,
    //     Dlimloss_95,
    //     Dlimtcr
    // } = calculatePHS(params);
    const calculatedResults = calculatePHS(params);
    setResults(calculatedResults);
    

    const calculatedWBGT = calculateWBGT({
                                          Ta: params.Ta,
                                          RH: params.RH,
                                          Tg: params.Tg,
                                          D: 15, // Valeur fixe si elle ne dépend pas de params
                                          Va: params.Va,
                                        });
    setwbgt(calculatedWBGT);

    const Tr = calculateTr(params.Tg, params.Va, params.Ta)


    console.log('WBGT_stull', calculatedWBGT.WBGT_stull)
    console.log('WBGT', calculatedWBGT.WBGT)
    
    console.log('Dlimtcr', calculatedResults.Dlimtcr)
    console.log('Dlimloss_95', calculatedResults.Dlimloss_95)
    console.log('Dlimloss_50', calculatedResults.Dlimloss_50)

  }, [params]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // setParams((prev) => ({ ...prev, [name]: parseFloat(value) || value }));
    setParams((prevParams) => {
      let updatedParams = { ...prevParams, [name]: parseFloat(value) || value };
  
      // Si Va est modifié, recalculer Tg en gardant Tr constant
      if (name === "Va") {
        // const Tr = calculateTr(prevParams.Tg, value, prevParams.Ta); // Calculer Tr à partir des valeurs actuelles
        updatedParams.Tg = calculateTgFromTr(Tr, value, prevParams.Ta);
      }
      else if(name === "Ta"){
        // const Tr = calculateTr(prevParams.Tg, prevParams.Va, value); // Calculer Tr à partir des valeurs actuelles
        updatedParams.Tg = calculateTgFromTr(Tr, prevParams.Va, value);
      }
  
      return updatedParams;
    });
  };

  // Recalcule `TcreData` dès que `results` change
//   useEffect(() => {

//     const timeLabels = results.map((data) => data.time);
//     const TreData = results.map((data) => data.Tre);
//     const TcrData = results.map((data) => data.Tcr);
//     const TskData = results.map((data) => data.Tsk);

//     SetTcreData ({
//       labels: timeLabels,
//       datasets: [
//         {
//           label: "Tre (°C)",
//           data: TreData,
//           borderColor: "red",
//           borderWidth: 2,
//           fill: false,
//         },
//         {
//           label: "Tcr (°C)",
//           data: TcrData,
//           borderColor: "blue",
//           borderWidth: 2,
//           fill: false,
//         },
//         {
//           label: "Tsk (°C)",
//           data: TskData,
//           borderColor: "green",
//           borderWidth: 2,
//           fill: false,
//         },
//       ],
//     });
//     SetsweatLossData ({
//         labels: timeLabels,
//         datasets: [
//             {
//             label: "SWtot (g)",
//             data: SWtotData,
//             borderColor: "purple",
//             borderWidth: 2,
//             fill: false,
//             },
//         ],
//       });

//   }, [results]);

    useEffect(() => {
        if (!results.PHS_data || !Array.isArray(results.PHS_data)) {
        console.warn("PHS_data is not an array or is unavailable:", results);
        return;
        }
    
        const timeLabels = results.PHS_data.map((data) => data.time);
        const TreData = results.PHS_data.map((data) => data.Tre);
        const TcrData = results.PHS_data.map((data) => data.Tcr);
        const TskData = results.PHS_data.map((data) => data.Tsk);

        const SWtotData = results.PHS_data.map((data) => data.SWtot);
        const SWtotgData = results.PHS_data.map((data) => data.SWtotg);
        const DmaxData = results.PHS_data.map((data) => data.Dmax);
        const Dmax_50Data = results.PHS_data.map((data) => data.Dmax_50);
        
    
        SetTcreData({
        labels: timeLabels,
        datasets: [
            {
            label: "Tre (°C)",
            data: TreData,
            borderColor: "red",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 2,
            fill: false,
            },
            {
            label: "Tcr (°C)",
            data: TcrData,
            borderColor: "blue",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 2,
            fill: false,
            },
            {
            label: "Tsk (°C)",
            data: TskData,
            borderColor: "green",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 2,
            fill: false,
            },
            {
            label: "38 (°C)",
            data: Array.from({ length: TreData.length }).fill(38),
            borderColor: "grey",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 1,
            fill: false,
            },
            {
            label: "39.5 (°C)",
            data: Array.from({ length: TreData.length }).fill(39.5),
            borderColor: "black",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 1,
            fill: false,
            },
        ],
        });
    
        SetsweatLossData({
        labels: timeLabels,
        datasets: [
            {
            label: "SWtot (g)",
            data: SWtotgData,
            borderColor: "purple",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 2,
            fill: false,
            },
            {
            label: "Perte hydrique max en g pour (95% des sujets)",
            data: DmaxData,
            borderColor: "grey",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 1,
            fill: false,
            },
            {
            label: "Perte hydrique max en g pour un individu moyen, (50% des sujets)",
            data: Dmax_50Data,
            borderColor: "black",
            // tension: 0.3,
            // spanGaps: true, // Ajoutez cette ligne pour ignorer les valeurs nulles entre les points
            pointRadius: 0, // Masquer les points
            borderWidth: 1,
            fill: false,
            },
        ],
        });
    }, [results]);
  



  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: true, position: "top" },
      title: { display: true, text: "Tre, Tcr, Tsk vs Time" },
    },
  };

  return (
    <div className="container mt-4">
        <h1 className="mb-4">PHS Calculation and Visualization</h1>
        <Row>
        <Col>
        <Form>
            <Row>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Air Temperature (Ta, °C)</Form.Label>
                  <Form.Range name="Ta" min="20" max="50" value={params.Ta} onChange={(e) => handleChange(e)}/>
                  <Form.Control type="number" name="Ta" min="20" max="50" value={params.Ta} onChange={(e) => handleChange(e)}/>
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Relative Humidity (RH, %)</Form.Label>
                  <Form.Range name="RH" min="0" max="100" value={params.RH} onChange={(e) => handleChange(e)}/>
                  <Form.Control type="number" name="RH" min="0" max="100" value={params.RH} onChange={(e) => handleChange(e)}/>
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Globe Temperature (Tg, °C)</Form.Label>
                  <Form.Range name="Tg" min="30" max="80" value={params.Tg} onChange={(e) => handleChange(e)}/>
                  <Form.Control type="number" name="Tg" min="30" max="80" value={params.Tg} onChange={(e) => handleChange(e)}/>
                  <p>Tr: {Tr} °C</p>
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Wind Speed (m/s)</Form.Label>
                  <Form.Range name="Va" min="0.1" max="10" value={params.Va} onChange={(e) => handleChange(e)}/>
                  <Form.Control type="number" name="Va" min="0.1" max="10" value={params.Va} onChange={(e) => handleChange(e)}/>
                </Form.Group>
              </Col>
              {/* <Col sm={6}>
                      <Form.Group>
                      <Form.Label>Duration (minutes)</Form.Label>
                      <Form.Control type="number" name="Duration" defaultValue={params.Duration} onChange={handleChange} />
                  </Form.Group>
              </Col> */}
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Métabolisme énergétique  (M, W)</Form.Label>
                  <Form.Range name="M" min="115" max="520" value={params.M} onChange={(e) => handleChange(e)}/>
                  <Form.Control type="number" name="M" min="115" max="520" value={params.M} onChange={(e) => handleChange(e)}/>
                </Form.Group>
              </Col>
              {/* <Col sm={6}>
                <Form.Group>
                  <Form.Label>Métabolisme énergétique  (M, W)</Form.Label>
                  <Form.Range name="M" min="115" max="520" value={params.M} onChange={(e) => handleChange(e)}/>
                  <Form.Control type="number" name="M" min="115" max="520" value={params.M} onChange={(e) => handleChange(e)}/>
                </Form.Group>
              </Col> */}
            </Row>
            <br></br>
            <br></br>
            <br></br>
            <Row>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Acclimatization</Form.Label>
                  <Form.Check
                    type="switch"
                    id="accl-switch"
                    label={params.Accl ? "Yes" : "No"}
                    checked={params.Accl === 1}
                    onChange={(e) =>
                      setParams((prev) => ({
                        ...prev,
                        Accl: e.target.checked ? 1 : 0,
                      }))
                    }
                  />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Drinking supply</Form.Label>
                  <Form.Check
                    type="switch"
                    id="drink-switch"
                    label={params.Drink ? "Yes" : "No"}
                    checked={params.Drink === 1}
                    onChange={(e) =>
                      setParams((prev) => ({
                        ...prev,
                        Drink: e.target.checked ? 1 : 0,
                      }))
                    }
                  />
                </Form.Group>
              </Col>


              {/* <Col sm={6}>
                <Form.Group>
                  <Form.Label>Relative Humidity (RH, %)</Form.Label>
                  <Form.Range name="RH" min="0" max="100" value={params.RH} onChange={(e) => handleChange(e)} />
                  <Form.Control type="number" name="RH" min="0" max="100" value={params.RH} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Air Temperature (Ta, °C)</Form.Label>
                  <Form.Range name="Ta" min="0" max="60" value={params.Ta} onChange={(e) => handleChange(e)} />
                  <Form.Control type="number" name="Ta" min="0" max="60" value={params.Ta} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col> */}
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Weight (kg)</Form.Label>
                  <Form.Control type="number" name="Weight" min="30" max="150" value={params.Weight} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Height (m)</Form.Label>
                  <Form.Control type="number" name="Height" min="1" max="2.5" step="0.01" value={params.Height} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Duration (minutes)</Form.Label>
                  <Form.Control type="number" name="Duration" min="1" max="1440" value={params.Duration} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Clothing Insulation (Icl, clo)</Form.Label>
                  <Form.Control type="number" name="Icl" min="0" max="2" step="0.1" value={params.Icl} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>

              {/* <Col sm={6}>
                <Form.Group>
                  <Form.Label>Metabolic Rate (Work, W/m²)</Form.Label>
                  <Form.Control type="number" name="Work" min="0" max="500" step="1" value={params.Work} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col> */}



              {/* <Col sm={6}>
                <Form.Group>
                  <Form.Label>Acclimatization (1 = Yes, 0 = No)</Form.Label>
                  <Form.Select 
                    name="Accl" 
                    value={params.Accl} 
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Drinking Habits (1 = Adequate, 0 = Inadequate)</Form.Label>
                  <Form.Select 
                    name="Drink" 
                    value={params.Drink} 
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="1">Adequate</option>
                    <option value="0">Inadequate</option>
                  </Form.Select>
                </Form.Group>
              </Col> */}


              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Posture</Form.Label>
                  <Form.Select name="posture" value={params.posture} onChange={(e) => handleChange(e)}>
                    <option value="1">Standing</option>
                    <option value="2">Sitting</option>
                    <option value="3">Lying</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Evaporative Resistance (Ecl, m²·kPa/W)</Form.Label>
                  <Form.Control type="number" name="Ecl" min="0" max="1" step="0.01" value={params.Ecl} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Ap (Fraction of Body Surface)</Form.Label>
                  <Form.Control type="number" name="Ap" min="0" max="1" step="0.01" value={params.Ap} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Fr (Fraction of Radiative Surface)</Form.Label>
                  <Form.Control type="number" name="Fr" min="0" max="1" step="0.01" value={params.Fr} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>Imst (Impermeability Index)</Form.Label>
                  <Form.Control type="number" name="imst" min="0" max="1" step="0.01" value={params.imst} onChange={(e) => handleChange(e)} />
                </Form.Group>
              </Col>



            </Row>


            
          </Form>
        </Col>

        <Col>
        <h2>WBGT_stull: {wbgt.WBGT_stull} °C</h2>
        <h2>WBGT: {wbgt.WBGT} °C</h2>

        <h2>Dlimtcr: {results.Dlimtcr} min</h2>
        <h2>Dlimloss_95: {results.Dlimloss_95} min</h2>
        <h2>Dlimloss_50: {results.Dlimloss_50} min</h2>
        </Col>
        </Row>





      <Row>
        <Col>
          {TcreData && (
            <>
              <div className="mt-5">
                <h3>Core and Skin Temperature Over Time</h3>
                <Line data={TcreData} options={chartOptions} />
              </div>
            </>
          )}
        </Col>
        <Col>
          {sweatLossData && (
            <>
              <div className="mt-5">
                <h3>Total Sweat Loss Over Time</h3>
                <Line
                  data={sweatLossData}
                  options={{
                    ...chartOptions,
                    plugins: { ...chartOptions.plugins, title: { text: "SWtot vs Time" } },
                  }}
                />
              </div>
            </>
          )}
        </Col>
      </Row>

      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>


    </div>
  );
}

export default PHS;






